<template>
  <Card
    :key="state.item.id"
    class="koc-default-collection-item-toolkit"
    :image-url="state.imageUrl"
    :show-overlay="!state.hasAccess"
    :content-title="state.item.title"
    :content-link="state.item.downloads ? FormattingService.formatDownloadUrl(state.item.downloads) : '#'"
    :content-body="state.item.excerpt"
    :show-ribbon="state.isNew"
  >
    <template #footer>
      <div class="koc-default-collection-item-toolkit-footer">
        <div class="koc-default-collection-item-toolkit-footer-link koc-title koc-montserrat">
          <div v-if="item.downloads">
            <a :href=" FormattingService.formatDownloadUrl(item.downloads)">
              {{ item.downloads[0].type === 'zip' ? 'DOWNLOAD' : 'VIEW' }}
            </a>
          </div>
          <div v-else>
            <a @click="toggleModal(item)">
              VIEW CODE
            </a>
          </div>
        </div>
        <div class="koc-default-collection-item-toolkit-footer-icon">
          <tooltip
            text="More Information"
            :last="true"
          >
            <button
              class="koc-button koc-ripple koc-clear koc-small koc-text"
              @click="toggleModal(item)"
            >
              <font-awesome-icon
                :icon="['fa', 'info']"
              />
            </button>
          </tooltip>
        </div>
      </div>
    </template>
  </Card>
</template>

<script src="./toolkit.js"></script>
<style lang="scss" scoped src="./toolkit.scss"></style>
